import * as React from 'react';

import FormWarningsProvider from 'contexts/FormWarningsProvider';
import type { EventDefinitionType } from 'components/event-definitions/types';
import AssetEventForm from 'security-app/components/AssetEvents/AssetEventForm';
import EventsSecurityLicenseStatus from 'security-app/components/AssetEvents/EventsSecurityLicenseStatus';

const AssetEventFormContainer: EventDefinitionType['formComponent'] = (props) => {
  const { eventDefinition, onChange, validation } = props;

  return (
    <FormWarningsProvider>
      <EventsSecurityLicenseStatus>
        <AssetEventForm eventDefinition={eventDefinition} onChange={onChange} validation={validation} />
      </EventsSecurityLicenseStatus>
    </FormWarningsProvider>
  );
};

export default AssetEventFormContainer;
